import { ALL_OPTIONS_VALUE } from './common';

export const LOGIN_QUERY_KEY = {
  IS_TEMP_PASSWORD: 'is_temp_password',
  ACCESS: 'access',
  REFRESH: 'refresh',
};

export const MFA_DEVICE_TYPE = {
  APP_DEVICE: 'app_device',
  EMAIL_DEVICE: 'email_device',
};

export const LOGIN_BG_TEXT = 'Be the change you want to see.';
export const REGISTRATION_BG_TEXT = 'Build the culture you aspire to have';
export const PASS_MIN_LENGTH = 12;

export const USER_LOGIN_TYPE = {
  LOGIN: 'Login',
  MFA: 'MFA',
  SSO: 'SSO',
};

export const LOGIN_TYPE_FILTER_OPTIONS = [ALL_OPTIONS_VALUE, ...Object.values(USER_LOGIN_TYPE)];
